var map = {
	"./About": 411,
	"./About.jsx": 411,
	"./AboutDescriptionLeft": 2686,
	"./AboutDescriptionLeft.jsx": 2686,
	"./AboutDescriptionRight": 6257,
	"./AboutDescriptionRight.jsx": 6257,
	"./ContactUs": 6046,
	"./ContactUs.jsx": 6046,
	"./Dish": 6551,
	"./Dish.jsx": 6551,
	"./DishModal": 3661,
	"./DishModal.jsx": 3661,
	"./DishModalDetail": 3356,
	"./DishModalDetail.jsx": 3356,
	"./DishModalHeroImage": 2783,
	"./DishModalHeroImage.jsx": 2783,
	"./Footer": 642,
	"./Footer.jsx": 642,
	"./Header": 7084,
	"./Header.jsx": 7084,
	"./Home": 4451,
	"./Home.jsx": 4451,
	"./Menu": 2467,
	"./Menu.jsx": 2467,
	"./MenuSection": 4421,
	"./MenuSection.jsx": 4421,
	"./Navigation": 8957,
	"./Navigation.jsx": 8957,
	"./NotFound": 2725,
	"./NotFound.jsx": 2725,
	"./data/aboutus": 6855,
	"./data/aboutus.json": 6855,
	"./data/dishes": 2929,
	"./data/dishes.json": 2929,
	"./data/food-icons": 2785,
	"./data/food-icons.json": 2785,
	"./dishImages/chicken_noodle_soup.jpg": 148,
	"./dishImages/crispy_noodle_salad_prawn_sq.jpg": 958,
	"./dishImages/crispy_noodle_salad_veg_sq.jpg": 6042,
	"./dishImages/crispy_veg_noodle.jpg": 6237,
	"./dishImages/ginger_chicken.jpg": 8174,
	"./dishImages/krapow_sq.jpg": 3808,
	"./dishImages/massaman.jpg": 1646,
	"./dishImages/pad_thai.jpg": 929,
	"./dishImages/pad_thai_prawn.jpg": 3098,
	"./dishImages/pad_thai_veg_sq.jpg": 900,
	"./dishImages/panang_beef_sq.jpg": 1337,
	"./dishImages/prawn_crackers_sq.jpg": 8521,
	"./dishImages/red_curry_sq.jpg": 7852,
	"./dishImages/red_pork_salad.jpg": 2343,
	"./dishImages/rice_ball.jpg": 9463,
	"./dishImages/rice_ball_salad.jpg": 7854,
	"./dishImages/satay_chicken.jpg": 3224,
	"./dishImages/spicy_chicken_salad.jpg": 9325,
	"./dishImages/spicy_prawn_salad_sq.jpg": 635,
	"./dishImages/thai_green_curry.jpg": 7125,
	"./dishImages/tom_yum_veg.jpg": 1405,
	"./font/OFL.txt": 4874,
	"./font/Philosopher-Bold.ttf": 1926,
	"./font/Philosopher-BoldItalic.ttf": 3461,
	"./font/Philosopher-Italic.ttf": 304,
	"./font/Philosopher-Regular.ttf": 7301,
	"./icons/OIE-front-logo.jpg": 2281,
	"./icons/OIE-logo-purple.png": 5351,
	"./icons/OIE-logo-white.png": 1520,
	"./icons/contains-nuts.png": 6948,
	"./icons/facebook_icon.png": 271,
	"./icons/instagram_icon.png": 8191,
	"./icons/location_icon.png": 5451,
	"./icons/twitter_icon.png": 84,
	"./icons/vegan-icon.jpg": 2295,
	"./icons/vegetarian-icon.jpg": 1906,
	"./otherImages/HERO.jpg": 9142,
	"./otherImages/OIE_2.jpeg": 8921,
	"./otherImages/Oie_1.jpg": 6721,
	"./otherImages/oie_b_and_w.jpg": 8019,
	"./utils": 1247,
	"./utils.js": 1247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 744;